// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__1wYso","lds-ripple":"Loader_lds-ripple__SZn0-","center":"Loader_center__3huDO"};